import {helpers} from 'vuelidate/lib/validators';

export const texte = helpers.regex('texte', /^[A-zÀ-ú -]*$/);
